import { useState } from "react";
import { Heart } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useWishlist } from "@/context/WishlistContext";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function HeartButton({ productId, className = "", size = "w-5 h-5" }) {
  const wl = useWishlist();
  const { user } = useAuth();
  const navigate = useNavigate();
  const [pop, setPop] = useState(false);
  const hearted = wl?.isHearted(productId);

  const onClick = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!user) return navigate("/auth?mode=login");
    if (user.role !== "buyer") return;
    setPop(true);
    setTimeout(() => setPop(false), 360);
    const added = await wl.toggle(productId);
    if (added) toast.success("Saved to your wishlist");
  };

  if (user && user.role === "seller") return null;

  return (
    <button
      onClick={onClick}
      data-testid={`heart-${productId}`}
      aria-label="Save to wishlist"
      className={`flex items-center justify-center rounded-full glass-dark w-9 h-9 transition-transform ${pop ? "heart-pop" : ""} ${className}`}
    >
      <Heart className={`${size} transition-colors ${hearted ? "fill-aura-accent text-aura-accent" : "text-white"}`} />
    </button>
  );
}
